import Vue from 'vue'
import {
    MLInstaller,
    MLCreate,
    MLanguage
} from 'vue-multilanguage'

Vue.use(MLInstaller)

export default new MLCreate({
    initial: 'pt',
    save: process.env.NODE_ENV === 'production',
    languages: [
        new MLanguage('pt').create({
            'Usuário': 'Usuário',
            'Senha': 'Senha',
            'Entrar': 'Entrar',
            'Digite o seu nome de usuário': 'Digite o seu nome de usuário',
            'Digite a senha': 'Digite a senha',
            'Não foi possível obter o tempo restante da utilização.': 'Não foi possível obter o tempo restante da utilização.',
            'The user credentials were incorrect': 'As credenciais do usuário estão incorretas',
        }),

        new MLanguage('en').create({
            'Usuário': 'Username',
            'Senha': 'Password',
            'Entrar': 'Enter',
            'Digite o seu nome de usuário': 'Enter your username',
            'Digite a senha': 'Type the password',
            'Não foi possível obter o tempo restante da utilização.': 'Unable to get remaining usage time.',
            'The user credentials were incorrect': 'The user credentials were incorrect',
        }),

        new MLanguage('es').create({
            'Usuário': 'Nombre de usuario',
            'Senha': 'Contraseña',
            'Entrar': 'Entrar',
            'Digite o seu nome de usuário': 'Ingrese su nombre de usuario',
            'Digite a senha': 'Escriba la contraseña',
            'Não foi possível obter o tempo restante da utilização.': 'No se puede obtener el tiempo de uso restante.',
            'The user credentials were incorrect': 'Las credenciales de usuario eran incorrectas',
        })
    ]
})